if (!customElements.get('clock-strip')) {
  customElements.define(
    'clock-strip',
    class ClockStrip extends HTMLElement {
      connectedCallback() {
        this.hour12 = this.dataset.format === '12h';
        this.clocks = this.querySelectorAll('[data-tz]');
        this.tick();
        this.timer = setInterval(() => this.tick(), 20000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const now = new Date();
        const locale = this.hour12 ? 'en-US' : 'en-GB';
        this.clocks.forEach((clock) => {
          try {
            clock.textContent = new Intl.DateTimeFormat(locale, {
              hour: '2-digit',
              minute: '2-digit',
              hour12: this.hour12,
              timeZone: clock.dataset.tz,
            }).format(now);
          } catch (error) {
            clock.textContent = '--:--';
          }
        });
      }
    }
  );
}
